import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn} from '../../ui_utils/DomUtils'
import {UIGameManager} from '../UIGameManager'
import {UIGameHelpButtonsController} from './UIGameHelpButtonsController'
import {getImagePath} from '../../ui_utils/Utils'

export class UIGameHelpButton {
    protected readonly uiGameHelpButtonController: UIGameHelpButtonsController
    protected readonly uiGameManager: UIGameManager

    readonly content: HTMLDivElement // Holds elements that are shown if the button is clicked
    readonly gameHelpButtonContainer: HTMLDivElement // Holds all elements created by this help button, including the button itself
    private readonly image: HTMLImageElement

    active = true

    // for managing closure of containers on click outside them
    mouseDownRecently = false

    constructor(uiGameHelpButtonController: UIGameHelpButtonsController, parent: HTMLDivElement, className: string, img: LobbyImage) {
        this.uiGameHelpButtonController = uiGameHelpButtonController
        this.uiGameManager = uiGameHelpButtonController.uiGameManager
        this.gameHelpButtonContainer = createDivIn(parent, className)
        this.image = createImgIn(this.gameHelpButtonContainer, img, 'help-button-img darken-on-hover')
        this.content = createDivIn(this.gameHelpButtonContainer, '')
        this.content.onpointerdown = () => {
            this.mouseDownRecently = true
        }

        this.image.addEventListener('click', (event: PointerEvent) => this.clicked(event))
        this.setContainerActive(false)
    }

    clicked(event: PointerEvent) {
        this.mouseDownRecently = true
        if(this.active) {
            this.uiGameHelpButtonController.closeAllContainers()
        } else {
            this.uiGameHelpButtonController.closeAllContainers()
            this.setContainerActive(true)
        }
    }

    setContainerActive(visible: boolean) {
        if(this.active === visible) return

        this.active = visible
        const display = visible ? 'inline-block' : 'none'
        this.content.style.display = display
    }

    swapImage(img: string) {
        if(this.image.src == img) return
        this.image.src = getImagePath(img)
    }
}
